export const GET_LAYER_HISTORY_FROM_API = "GET_LAYER_HISTORY_FROM_API";
export const SET_LAYER_HISTORY = "SET_LAYER_HISTORY";

export const UNDO_LAYER_TO_LOCAL_STORAGE = "UNDO_LAYER_TO_LOCAL_STORAGE";
export const UNDO_LAYER = "UNDO_LAYER";
export const REDO_LAYER_TO_LOCAL_STORAGE = "REDO_LAYER_TO_LOCAL_STORAGE";
export const REDO_LAYER = "REDO_LAYER";
export const RESET_LAYER_TO_LOCAL_STORAGE = "RESET_LAYER_TO_LOCAL_STORAGE";
export const RESET_LAYER = "RESET_LAYER";


export const UPDATE_LAYER_TO_API = "UPDATE_LAYER_TO_API";
export const UPDATE_FEATURES = "UPDATE_FEATURES";

export const DELETE_FEATURES_FROM_LAYER_STORAGE = "DELETE_FEATURES_FROM_LAYER_STORAGE";
export const DELETE_FEATURES = "DELETE_FEATURES";

export const ADD_FEATURES_TO_LAYER_STORAGE = "ADD_FEATURES_TO_LAYER_STORAGE";
export const ADD_FEATURES = "ADD_FEATURES";

export const COMBINE_FEATURES_TO_LAYER_STORAGE = "COMBINE_FEATURES_TO_LAYER_STORAGE";
export const COMBINE_FEATURES = "COMBINE_FEATURES";

export const UNCOMBINE_FEATURES_TO_LAYER_STORAGE = "UNCOMBINE_FEATURES_TO_LAYER_STORAGE";
export const UNCOMBINE_FEATURES = "UNCOMBINE_FEATURES"